import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_inbound_receiving_package",
  ref: "InboundReceivingPackageModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-800px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_inbound_receiving_package_header"
}
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = { class: "fw-bolder" }
const _hoisted_7 = { class: "text-gray-400" }
const _hoisted_8 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_9 = { class: "svg-icon svg-icon-1" }
const _hoisted_10 = { class: "modal-body p-17" }
const _hoisted_11 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_modal_inbound_receiving_package_scroll",
  "data-kt-scroll": "false",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_inbound_receiving_package_header",
  "data-kt-scroll-wrappers": "#kt_modal_inbound_receiving_package_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-12" }
const _hoisted_14 = { class: "d-flex" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  src: "media/svg/custom/scan_code.svg",
  class: "w-240px me-14"
}, null, -1)
const _hoisted_16 = { class: "flex-fill d-flex flex-column justify-content-between" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { class: "d-flex justify-content-end" }
const _hoisted_20 = {
  ref: "submitButton",
  type: "submit",
  class: "btn btn-lg btn-primary"
}
const _hoisted_21 = { class: "indicator-label" }
const _hoisted_22 = { class: "svg-icon svg-icon-3 me-2 ms-0" }
const _hoisted_23 = { class: "indicator-progress" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.submitType === 1
                  ? _ctx.t("inbound.receivingPackage")
                  : _ctx.t("inspection.overviewChecking")), 1),
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.subTitle), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createVNode(_component_el_form, {
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
          model: _ctx.formData,
          rules: _ctx.rules,
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _createElementVNode("div", _hoisted_16, [
                        (_ctx.submitType === 1)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "text-base",
                              innerHTML: _ctx.t('inbound.pleaseScanLabel')
                            }, null, 8, _hoisted_17))
                          : (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: "text-base",
                              innerHTML: _ctx.t('inspection.plsScanLabel')
                            }, null, 8, _hoisted_18)),
                        _createVNode(_component_el_form_item, { prop: "barcode" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              class: "line-style fw-bolder",
                              ref: "barcodeRef",
                              modelValue: _ctx.formData.barcode,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.barcode) = $event)),
                              modelModifiers: { trim: true },
                              type: "text"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("button", _hoisted_20, [
                            _createElementVNode("span", _hoisted_21, [
                              _createElementVNode("span", _hoisted_22, [
                                (_ctx.submitType === 1)
                                  ? (_openBlock(), _createBlock(_component_inline_svg_icon, {
                                      key: 0,
                                      src: "media/icons/duotune/general/gen043.svg"
                                    }))
                                  : (_openBlock(), _createBlock(_component_inline_svg_icon, {
                                      key: 1,
                                      src: "media/icons/duotune/arrows/arr064.svg"
                                    }))
                              ]),
                              _createElementVNode("span", null, _toDisplayString(_ctx.submitType === 1
                                ? _ctx.t("inbound.received")
                                : _ctx.t("common.submit")), 1)
                            ]),
                            _createElementVNode("span", _hoisted_23, [
                              _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                              _hoisted_24
                            ])
                          ], 512)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])), [
              [_directive_loading, _ctx.loading]
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ], 512))
}